import {http} from './config';
export default{
    listarImagenesBases:()=>{
        return http.get('api/imagenesbases');
    },
    save:(imagenesBase)=>{
        return http.post('api/imagenesbase',imagenesBase)
    },
    delete:(imagenesBase)=>{
        return http.delete('api/imagenesbase/'+imagenesBase.id)
    },
    update:(imagenesBase)=>{

            return http({method:'PUT', url:('/api/imagenesbase/'+imagenesBase.id), data:imagenesBase})
    }
    ,
    obtenerImgPorDescripcion:(descripcion)=>{
        return http.get('/api/imagenes_base/obtener_img_por_descripcion/'+descripcion);
    }


}
